export const SESSION_TIMEOUT = 20;

export const hubEnvConfig = Object.freeze({
	SIGNALR_HUB: "http://localhost:9876/skillInsightHub",
	HUB_PRODUCT_CODE: "{EE99AC40-19D4-44E5-ABC5-69668901C193},{7EED109D-BCAC-43BC-9446-2EF0EB738E86}",
	HUB_USB_SERVICE_TYPES: "HidUsb,WUDFWpdMtp,RtlWlanu,disk",
	HUB_ANALYSIS_RESULT_FOLDERS: "MotionDetected,MultiFaceDetected,NoFaceDetected,RandomCapture,AudioDetected",
	HUB_UPLOAD_ALLOWED_FILETYPES: ".log,.jpg,.wav",
	HUB_CLEAR_USER_DATA: "N",
	TIMER_EXAM_LOADING: 10,
	TIMER_EXT_DEVICE: 30
});

export const getEnvConfig = () => {
	const host = window.location.host;
	console.log('Current Host:', host);
	const envConfigs = {
		'localhost:3001': {
			AC_BASE_URL: 'https://ac-dev.quintiles.com/',
			MICROSERVICE_BASE_URL: 'https://ac-dev.quintiles.com/skillinsight/api/',
			PYTHON_BASE_URL: 'http://localhost:8002/api/',
			MICROSERVICE_API_KEY: '2A77D5BD-B16E-4678-B74E-20727DF9D53B',
			REPHRASE_URL: 'http://localhost:5050/ask',
			OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2',
			OIDC_CLIENT_ID: '7cJ3kKmol6Pg8G2rFwXLcZdVhmIa',
			OIDC_CLIENT_SECRET: 'fONMJ9SvRfPBUqeYwCLaHVCCMHsa',
			OIDC_APP_KEY: 'SI-LCL-01-d9f61218-775b-4d94-b5aa-703403dd1662',
			OIDC_REDIRECT_URI: 'http://localhost:3001/dashboard/index',
			OIDC_RESPONSE_TYPE: 'code',
			OIDC_SCOPE: 'openid profile',
			OIDC_AUTHORITY_LOGOUT: 'https://dev2-fedsvc.solutions.iqvia.com/sessionout',
			OIDC_ROLE_TYPE: 'Reader',
			OIDC_USER_TYPE: 'External',
			OIDC_REREGISTER_USER_BASE_URL: 'https://dev2-sda.work.iqvia.com/sda-rest-api/api/external/entitlement/V1/ApplicationUsers',
			OIDC_ENCRYPT_KEY: 'E6AE0168-3968-40D9-88FF-12CE08C482EF',
			SIGNALR_SOFTWARE_DOWNLOAD_LINK: "https://ac-dev.quintiles.com/Resources/IQVIA.SkillInsight-1.0.0.0-Release-x64.msi",
			hubEnvConfig,
			SESSION_TIMEOUT
		},
		'skillinsightac-dev.gdev-car3-k8s.work.iqvia.com': {
			AC_BASE_URL: 'https://skillinsightac-dev.gdev-car3-k8s.work.iqvia.com/',
			MICROSERVICE_BASE_URL: 'https://skillinsight-dev.gdev-car3-k8s.work.iqvia.com/api/',
			PYTHON_BASE_URL: 'https://skillinsight-dev.gdev-car3-k8s.work.iqvia.com/api/',
			MICROSERVICE_API_KEY: '2A77D5BD-B16E-4678-B74E-20727DF9D53B',
			OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2',
			OIDC_CLIENT_ID: 'thr9PK4bnRROeTAuTC8_2kreEUIa',
			OIDC_CLIENT_SECRET: 'L3Ag8fseCa_jEqgknDEglFnHKTNpz0sta6tFagztURsa',
			OIDC_APP_KEY: 'SI-K8S-DEV-c613f1e6-9fdd-49c1-bae6-4117c576cd8a',
			OIDC_REDIRECT_URI: 'https://skillinsightac-dev.gdev-car3-k8s.work.iqvia.com/dashboard/index',
			OIDC_RESPONSE_TYPE: 'code',
			OIDC_SCOPE: 'openid profile',
			OIDC_AUTHORITY_LOGOUT: 'https://dev2-fedsvc.solutions.iqvia.com/sessionout',
			OIDC_ROLE_TYPE: 'Reader',
			OIDC_USER_TYPE: 'External',
			OIDC_REREGISTER_USER_BASE_URL: 'https://dev2-sda.work.iqvia.com/sda-rest-api/api/external/entitlement/V1/ApplicationUsers',
			OIDC_ENCRYPT_KEY: 'E6AE0168-3968-40D9-88FF-12CE08C482EF',
			SIGNALR_SOFTWARE_DOWNLOAD_LINK: "https://ac-dev.quintiles.com/Resources/IQVIA.SkillInsight-1.0.0.0-Release-x64.msi",
			hubEnvConfig,
			SESSION_TIMEOUT
		},
		'ac-dev.quintiles.com': {
			AC_BASE_URL: 'https://ac-dev.quintiles.com/',
			MICROSERVICE_BASE_URL: 'https://ac-dev.quintiles.com/skillinsight/api/',
			PYTHON_BASE_URL: 'https://ac-dev.quintiles.com/skillinsight/api/',
			MICROSERVICE_API_KEY: 'ASSESMENT-DEV-30649e64-2569-4c8a-bca6-5a1af796c59e',
			OIDC_AUTHORITY: 'https://dev2-fedsvc.solutions.iqvia.com/oauth2',
			REPHRASE_URL: 'http://localhost:5050/ask',
			OIDC_CLIENT_ID: 'DE1SxefKBuuDwVCqS40pIDUefnsa',
			OIDC_CLIENT_SECRET: 'KGjZI5aeerjACvuxzHavDPEwKfUa',
			OIDC_APP_KEY: 'ASSESMENT-DEV-30649e64-2569-4c8a-bca6-5a1af796c59e',
			OIDC_REDIRECT_URI: 'https://ac-dev.quintiles.com/dashboard/index',
			OIDC_RESPONSE_TYPE: 'code',
			OIDC_SCOPE: 'openid profile',
			OIDC_AUTHORITY_LOGOUT: 'https://dev2-fedsvc.solutions.iqvia.com/sessionout',
			OIDC_ROLE_TYPE: 'Reader',
			OIDC_USER_TYPE: 'External',
			OIDC_REREGISTER_USER_BASE_URL: 'https://dev2-sda.work.iqvia.com/sda-rest-api/api/external/entitlement/V1/ApplicationUsers',
			OIDC_ENCRYPT_KEY: 'E6AE0168-3968-40D9-88FF-12CE08C482EF',
			SIGNALR_SOFTWARE_DOWNLOAD_LINK: "https://ac-dev.quintiles.com/Resources/IQVIA.SkillInsight-1.0.0.0-Release-x64.msi",
			hubEnvConfig,
			SESSION_TIMEOUT
		},
		'ac-uat.quintiles.com': {
			AC_BASE_URL: 'https://ac-uat.quintiles.com/',
			MICROSERVICE_BASE_URL: 'https://ac-uat.quintiles.com/skillinsight/api/',
			PYTHON_BASE_URL: 'https://ac-uat.quintiles.com/skillinsight/api/',
			MICROSERVICE_API_KEY: '2A77D5BD-B16E-4678-B74E-20727DF9D53B',
			REPHRASE_URL: 'http://localhost:5050/ask',
			OIDC_AUTHORITY: 'https://uat-fedsvc.solutions.iqvia.com/oauth2',
			OIDC_CLIENT_ID: 'Lof36jBTNQdbKIn30KMeFlVce70a',
			OIDC_CLIENT_SECRET: 'Jg9IaJKkbInEsOFArYhFqX9WvhEa',
			OIDC_APP_KEY: 'RDS-DSSM-ASESUAT-530405d2-ef73-4bfb-93d5-d802b6337299',
			OIDC_REDIRECT_URI: 'https://ac-uat.quintiles.com/dashboard/index',
			OIDC_RESPONSE_TYPE: 'code',
			OIDC_SCOPE: 'openid profile',
			OIDC_AUTHORITY_LOGOUT: 'https://uat-fedsvc.solutions.iqvia.com/sessionout',
			OIDC_ROLE_TYPE: 'Reader',
			OIDC_USER_TYPE: 'External',
			OIDC_REREGISTER_USER_BASE_URL: 'https://uat-secapi.work.iqvia.com/sda-rest-api/api/external/entitlement/V1/ApplicationUsers',
			OIDC_ENCRYPT_KEY: 'E6AE0168-3968-40D9-88FF-12CE08C482EF',
			SIGNALR_SOFTWARE_DOWNLOAD_LINK: "https://ac-uat.quintiles.com/Resources/IQVIA.SkillInsight-1.0.0.0-Release-x64.msi",
			hubEnvConfig,
			SESSION_TIMEOUT
		},
		'ac.quintiles.com': {
			AC_BASE_URL: 'https://ac.quintiles.com/',
			MICROSERVICE_BASE_URL: 'https://ac.quintiles.com/skillinsight/api/',
			PYTHON_BASE_URL: 'https://ac.quintiles.com/skillinsight/api/',
			MICROSERVICE_API_KEY: '2A77D5BD-B16E-4678-B74E-20727DF9D53B',
			OIDC_AUTHORITY: 'https://fedsvc.myaccount.iqvia.com/oauth2',
			REPHRASE_URL: 'http://localhost:5050/ask',
			OIDC_CLIENT_ID: 'pHV9_3eXAzWrGx_hkYxWYlflQYoa',
			OIDC_CLIENT_SECRET: 'VyXkI4bqS3ifdihg9lGLCR02jLca',
			OIDC_APP_KEY: 'RDS-DSSM-ASESPRD-3fb481a7-e9a3-426f-bf43-ee33be745ec4',
			OIDC_REDIRECT_URI: 'https://ac.quintiles.com/dashboard/index',
			OIDC_RESPONSE_TYPE: 'code',
			OIDC_SCOPE: 'openid profile',
			OIDC_AUTHORITY_LOGOUT: 'https://fedsvc.myaccount.iqvia.com/sessionout',
			OIDC_ROLE_TYPE: 'Reader',
			OIDC_USER_TYPE: 'External',
			OIDC_REREGISTER_USER_BASE_URL: 'https://secapi.work.iqvia.com/sda-rest-api/api/external/entitlement/V1/ApplicationUsers',
			OIDC_ENCRYPT_KEY: 'E6AE0168-3968-40D9-88FF-12CE08C482EF',
			SIGNALR_SOFTWARE_DOWNLOAD_LINK: "https://ac.quintiles.com/Resources/IQVIA.SkillInsight-1.0.0.0-Release-x64.msi",
			hubEnvConfig,
			SESSION_TIMEOUT
		}
	};

	// Default to DEV if not matched
	return envConfigs[host] || envConfigs['ac-dev.quintiles.com'];
};